<template lang="pug">
  div.drug-button.btn.drug-button-by-med(
    @click="$emit('refillNewDrugStorage')"
    style="display: flex; justify-content: center; padding: 1.5rem 0"
  )
    span 無相同批號？補藥至新的藥盒
</template>

<script>
export default {
  name: 'RefillToNewDrugStorage',
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// RefillToNewDrugStorage.vue?bf36728a